export default "__VITE_ASSET__Bqvcdd4A__"